import React from 'react';
import SearchItem from './SearchItem';

export default class SearchItems extends React.PureComponent {
  render() {
    const {items} = this.props;

    return (
      <div className="row">
        {items.map(item => (
          <SearchItem
            key={item.id}
            slug={item.slug}
            imageSrc={item.images}
            header={item.name}
            price={item.price}
            text={item.shortDescription}
          />
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/searchItem/SearchItems.js